import React from 'react';
import { Ban, Plane, Sprout, CheckCircle } from 'lucide-react';
import { roleMeta } from './peopleUtils';

const Pill = ({ hex, children, testId }) => (
  <span data-testid={testId} className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[9px] font-semibold tracking-[0.1em] uppercase border whitespace-nowrap"
    style={{ background: `${hex}14`, borderColor: `${hex}40`, color: hex }}>{children}</span>
);

export const RolePill = ({ role }) => { const m = roleMeta(role); return <Pill hex={m.hex}>{m.label}</Pill>; };

export const StatusPills = ({ staff, onLeave, probation }) => (
  <div className="flex flex-wrap gap-1">
    {staff.is_suspended ? <Pill hex="#F43F5E"><Ban className="w-2.5 h-2.5" /> Suspended</Pill>
      : !onLeave && <Pill hex="#10B981"><CheckCircle className="w-2.5 h-2.5" /> Active</Pill>}
    {onLeave && <Pill hex="#38BDF8" testId={`on-leave-${staff.username}`}><Plane className="w-2.5 h-2.5" /> On leave</Pill>}
    {probation && <Pill hex="#F59E0B" testId={`probation-${staff.username}`}><Sprout className="w-2.5 h-2.5" /> Probation</Pill>}
  </div>
);
